import delivery from '../../../plugins/pca-ah71-1.0.5';
import billing from '../../../plugins/pca-jr17-1.0.5';
import Track from '../../utils/tracking';

export default {
  get: (addressType) => {
    if (addressType === 'delivery') {
      return delivery;
    }
    
    if (addressType === 'billing') {
      return billing;
    }
    
    Track.warn(`Unsupported addressType for postcode-anywhere: ${addressType}`);
  },
};
